// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2huAY","label":"Radio_label__Aty4A","checkMark":"Radio_checkMark__1Yhmy","disabled":"Radio_disabled__N33ki"};